import {
  FILTER_REVIEWS_BY_EVENT,
  FILTER_REVIEWS_BY_SCORE,
  RESET_REVIEWS_FILTER,
  OPEN_EVENT_FILTER_DROPDOWN,
  CLOSE_EVENT_FILTER_DROPDOWN,
  FEATURED_REVIEWS_LOADED,
  FEATURED_REVIEWS_UNLOADED,
  OPEN_REVIEW_IMAGE_MODAL,
  CLOSE_REVIEW_IMAGE_MODAL,
  PAGINATION_CHANGE_PAGE,
  PAGINATION_FIRST_PAGE,
  PAGINATION_LAST_PAGE,
  PAGINATION_NEXT_PAGE,
  PAGINATION_PREV_PAGE,
  RESET_CURRENT_PAGE_INDEX,
  CLEAR_REVIEWS,
  PRODUCT_REVIEWS_OK,
  PRODUCT_REVIEWS_NOT_OK,
  PRODUCT_REVIEWS_PAGINATION_OK,
  FEATURED_REVIEWS_OK,
  FEATURED_REVIEWS_NOT_OK,
  OPEN_SCORE_FILTER_DROPDOWN,
  CLOSE_SCORE_FILTER_DROPDOWN,
  ELEMENT_IS_SCROLL_READY,
  OPEN_REVIEWS_FILTER_MODAL,
  CLOSE_REVIEWS_FILTER_MODAL,
} from '../actions/reviews'

import {REVIEWS_PER_PAGE, EVENT_TYPE_ALL, SCORE_TYPE_ALL} from '../const'

const initialState = {
  currentPageIndex: 0,
  currentReviewImage: null,
  featuredReviews: null,
  featuredReviewsIsLoaded: false,
  pageCount: null,
  reviewsPagination: [],
  productReviews: null,
  reviewImageModalIsOpen: false,
  reviewPagesCount: null,
  eventFilterDropdownIsOpen: false,
  scoreFilterDropdownIsOpen: false,
  fetchError: null,
  totalReviews: 0,
  averageScore: 0,
  currentEventFilter: EVENT_TYPE_ALL,
  currentScoreFilter: SCORE_TYPE_ALL,
  scrollReady: false,
  reviewsFilterModalIsOpen: false,
}

export default function reducer(state = initialState, action) {
  let newState

  switch (action.type) {
    case FEATURED_REVIEWS_NOT_OK: {
      newState = {
        featuredReviews: false,
        fetchError: action.payload,
      }
      break
    }

    case FEATURED_REVIEWS_OK: {
      newState = {
        featuredReviews: action.payload.reviews,
        totalReviews: action.payload.bottomline.total_review,
        averageScore: action.payload.bottomline.average_score,
      }
      break
    }

    case PRODUCT_REVIEWS_NOT_OK: {
      newState = {
        productReviews: false,
        fetchError: action.payload,
      }
      break
    }

    case PRODUCT_REVIEWS_OK: {
      newState = {
        productReviews: action.payload,
        totalReviews: action.payload.totalReviews,
        averageScore: parseFloat(action.payload.averageScore),
      }
      break
    }

    case CLEAR_REVIEWS:
      newState = {
        averageScore: 0,
        featuredReviews: null,
        fetchError: null,
        productReviews: null,
        reviewsPagination: [],
        totalReviews: 0,
        scrollReady: false,
      }
      break

    case RESET_REVIEWS_FILTER:
      newState = {
        currentEventFilter: EVENT_TYPE_ALL,
        currentScoreFilter: SCORE_TYPE_ALL,
      }
      break

    case OPEN_EVENT_FILTER_DROPDOWN:
      newState = {eventFilterDropdownIsOpen: true}
      break

    case CLOSE_EVENT_FILTER_DROPDOWN:
      newState = {eventFilterDropdownIsOpen: false}
      break

    case OPEN_SCORE_FILTER_DROPDOWN:
      newState = {scoreFilterDropdownIsOpen: true}
      break

    case CLOSE_SCORE_FILTER_DROPDOWN:
      newState = {scoreFilterDropdownIsOpen: false}
      break

    case OPEN_REVIEWS_FILTER_MODAL:
      newState = {reviewsFilterModalIsOpen: true}
      break

    case CLOSE_REVIEWS_FILTER_MODAL:
      newState = {reviewsFilterModalIsOpen: false}
      break

    case FILTER_REVIEWS_BY_SCORE:
      newState = {
        currentScoreFilter: action.payload,
        scoreFilterDropdownIsOpen: false,
        eventFilterDropdownIsOpen: false,
        currentPageIndex: 0,
      }
      break

    case FILTER_REVIEWS_BY_EVENT:
      newState = {
        currentEventFilter: action.payload,
        eventFilterDropdownIsOpen: false,
        scoreFilterDropdownIsOpen: false,
        currentPageIndex: 0,
      }
      break

    case FEATURED_REVIEWS_LOADED:
      newState = {featuredReviewsIsLoaded: true}
      break

    case FEATURED_REVIEWS_UNLOADED:
      newState = {featuredReviewsIsLoaded: false}
      break

    case OPEN_REVIEW_IMAGE_MODAL:
      newState = {
        reviewImageModalIsOpen: true,
        currentReviewImage: action.payload,
      }
      break

    case CLOSE_REVIEW_IMAGE_MODAL:
      newState = {reviewImageModalIsOpen: false}
      break

    case PRODUCT_REVIEWS_PAGINATION_OK:
      newState = {
        pageCount: Math.ceil(action.payload.length / REVIEWS_PER_PAGE),
        reviewsPagination: action.payload,
      }
      break

    case PAGINATION_FIRST_PAGE:
      newState = {currentPageIndex: 0}
      break

    case PAGINATION_LAST_PAGE:
      newState = {currentPageIndex: state.pageCount - 1}
      break

    case PAGINATION_NEXT_PAGE:
      newState = {currentPageIndex: state.currentPageIndex + 1}
      break

    case PAGINATION_PREV_PAGE:
      newState = {currentPageIndex: state.currentPageIndex - 1}
      break

    case PAGINATION_CHANGE_PAGE:
      newState = {currentPageIndex: action.payload.index}
      break

    case RESET_CURRENT_PAGE_INDEX:
      newState = {currentPageIndex: 0}
      break

    case ELEMENT_IS_SCROLL_READY: {
      newState = {scrollReady: true}
      break
    }

    default: {
      break
    }
  }
  return newState ? Object.assign({}, state, newState) : state
}
